import React, { useEffect, useRef, useState } from 'react';
import Styles from './ButtonStyles.module.scss';
import { MyPolicyCallByAction } from '../../../services/LoginServiceV2';
import RichText from '../../richtext';
import { replacePlaceholder } from '../../../utils/utils';
import {
  OTP_SMS_OLD,
  OTP_SMS_NEW,
  OTP_SMS,
  OTP_EMAIL,
  OTP_RESEND,
  LOGIN_MFA
} from '../../../utils/constants';
import { Spinner } from 'react-bootstrap';
import { OtpValidationScahema } from '../Login.types';
import mainStyles from '../ReusableLogin.module.scss';

const OtpValidation: React.FC<OtpValidationScahema> = ({
  useCase,
  mainContent,
  changeCurrentView,
  response,
  loginIcons,
  onSuccess,
  errorContent
}: any) => {
  const numberRegex: any = /^[0-9]+$/;
  const [error, setError] = useState(true);
  const [timer, setTimer] = useState<number>(0);
  const [countDown, setCountDown] = useState<boolean>(false);
  const [inputValue, setInputValue] = useState('');
  const [content, setContent] = useState<Record<string, any>>({});
  const [showLoader, setShowLoader] = useState<boolean>(false);
  const [wrongOtp, setWrongOtp] = useState(false);
  const [techError, setTechError] = useState(false);
  const [isResend, setIsResend] = useState<boolean>(false);
  const controllerRef = useRef<AbortController | null>(null);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e?.target?.value);
    setWrongOtp(false);
    setIsResend(false);
    if (numberRegex.test(e?.target?.value) && e?.target?.value?.length === 6) {
      setError(false);
    } else {
      setError(true);
    }
  };

  //To pickup content based on the response code
  useEffect(() => {
    if (mainContent) {
      if (useCase === OTP_SMS_OLD && mainContent?.smsOldSection?.length > 0) {
        setContent(mainContent?.smsOldSection?.[0]);
      }
      if (useCase === OTP_SMS_NEW && mainContent?.smsNewSection?.length > 0) {
        setContent(mainContent?.smsNewSection?.[0]);
      }
      if (useCase === OTP_SMS && mainContent?.otpSmsSection?.length > 0) {
        setContent(mainContent?.otpSmsSection?.[0]);
      }
      if (useCase === OTP_EMAIL && mainContent?.otpEmailSection?.length > 0) {
        setContent(mainContent?.otpEmailSection?.[0]);
      }
    }
  }, [mainContent]);

  //counter to enable resend otp after 60 sec
  useEffect(() => {
    if (countDown) {
      let i = mainContent?.OTPResendCount || 60;
      setTimer(i);
      const timerInterval = setInterval(() => {
        setTimer(--i);
        if (i <= 0) {
          clearInterval(timerInterval);
          setCountDown(false);
        }
      }, 1000);
      return () => {
        setCountDown(false);
        clearTimeout(timerInterval);
      };
    }
  }, [countDown]);

  //Starting the timer when the component loads
  useEffect(() => {
    setCountDown(true);
  }, []);

  const onClickHandler = () => {
    if (showLoader) {
      controllerRef?.current?.abort();
    }
    setIsResend(false);
    setShowLoader(true);
    setTechError(false);
    setWrongOtp(false);
    MyPolicyCallByAction(useCase, inputValue, controllerRef)
      .then((res: any) => {
        if (res?.status) {
          if (res?.status === 'OK') {
            localStorage.setItem('existingUser', 'true');
            onSuccess();
          } else if (res?.error === 'OTP_WRONG') {
            setWrongOtp(true);
          } else if (res?.status !== 'NOK' && res?.status !== 'ERROR') {
            changeCurrentView('', res);
          } else {
            setTechError(true);
          }
        } else {
          setTechError(true);
        }
        setShowLoader(false);
      })
      .catch((err) => {
        setShowLoader(false);
        setTechError(true);
        console.log(err);
      });
  };

  const onResendClick = () => {
    controllerRef?.current?.abort();
    setIsResend(true);
    setCountDown(true);
    MyPolicyCallByAction(OTP_RESEND, '', controllerRef).then((res: any) => {
      if (res?.status && res?.status !== 'NOK' && res?.status !== 'ERROR') {
        changeCurrentView('', res);
      } else {
        setTechError(true);
      }
    });
  };

  //for click of the link text in the description section
  const handleLinkClick = () => {
    controllerRef?.current?.abort();
    changeCurrentView('', { status: LOGIN_MFA });
  };

  const onKeyDown = (e: any) => {
    if (e?.key === 'Enter' && !(error || showLoader)) {
      onClickHandler();
    }
  };

  return (
    <div className={Styles.Container}>
      {content?.title && <h2 className='text-center mb-4 mt-4'>{content?.title}</h2>}
      {isResend && content?.resendInfo && (
        <>
          <div className={Styles.resendcontent}>
            <span style={{ display: 'inline-flex' }}>
              <div style={{ paddingRight: '10px' }}>
                <img src={loginIcons?.checkmark?.filename} alt='error' width={24} height={24} />{' '}
              </div>
              {content?.resendInfo && <RichText content={content?.resendInfo} />}
            </span>
          </div>
          <div className='mt-4' />
        </>
      )}
      <p>
        {content?.descriptionFirst && (
          <div>
            <RichText
              content={JSON.parse(
                replacePlaceholder(JSON.stringify(content?.descriptionFirst), [
                  response?.recipient ?? ' '
                ])
              )}
            />
          </div>
        )}
        <div>
          {content?.descSecStart && (
            <>
              <br />
              {content?.descSecStart}
            </>
          )}
          {content?.descSecSplitLink && (
            <span className={mainStyles.updatedetails} onClick={handleLinkClick}>
              {content?.descSecSplitLink}
            </span>
          )}
          {content?.descSecEnd && <>{content?.descSecEnd}</>}
        </div>
      </p>
      <div className={`form-floating  w-100 ${Styles.inputField}`}>
        <input
          type='number'
          id={useCase}
          placeholder='Temporary code'
          value={inputValue}
          className={`form-control ${(techError || wrongOtp) && 'error-border mb-4'}`}
          onChange={handleChange}
          onKeyDown={onKeyDown}
          maxLength={6}
          autoComplete='one-time-code'
          // disabled={error}
        />
        {content?.otpLabel && (
          <label className={`text-truncate w-100 ${mainStyles.loginmodalLabel}`}>
            {content?.otpLabel}
          </label>
        )}
        {wrongOtp && errorContent?.tempCodeError && (
          <p className={mainStyles.credentialerror}>
            <img
              src={loginIcons?.alertTriangle?.filename}
              alt='alert'
              className={mainStyles.warningicon}
            />
            {errorContent?.tempCodeError}
          </p>
        )}
        {techError && errorContent?.technicalError && (
          <p className={mainStyles.credentialerror}>
            <img
              src={loginIcons?.alertTriangle?.filename}
              alt='alert'
              className={mainStyles.warningicon}
            />
            {errorContent?.technicalError}
          </p>
        )}
      </div>
      {timer === 0 ? (
        <div
          className='text-center fw-bold mt-2'
          style={{ color: '#da291c' }}
          onClick={onResendClick}
        >
          {content?.resendCodeLabel ?? ''}
        </div>
      ) : (
        <div className='text-center fw-bold mt-2'>
          {replacePlaceholder(content?.resendTimeLabel, [timer]) ?? ''}
        </div>
      )}
      {content?.buttonLabel && (
        <div className='text-center mt-4'>
          {showLoader && (
            <Spinner
              as='span'
              animation='border'
              size='sm'
              role='status'
              aria-hidden='true'
              className='d-block mx-auto mb-3'
            />
          )}
          <button
            className={Styles.continueButton}
            disabled={error || showLoader}
            onClick={onClickHandler}
          >
            {content?.buttonLabel}
          </button>
        </div>
      )}
    </div>
  );
};

export default OtpValidation;
